import {useGlobal} from "reactn";

// Don`t forget update \Norlandia.Core\Helpers\ContentHelper.cs
export const GetTextColor = (bgColor) => {
  let color = bgColor?.replace(/ /g, "") || "";
  switch (color?.toLowerCase()) {
    case "8b1c93":
    case "rgb(45,132,42)":
    case "rgb(131,15,26)":
    case "rgb(41,41,42)":
    case "rgb(30,52,102)":
    case "rgb(139,28,147)":
    case "rgb(6,79,145)":
    case "ce3781":
    case "5e0065":
    case "1e3466":
    case "001443":
    case "2d842a":
    case "830f1a":
    case "29292a":
    case "515151":
    case "064f91":
    case "006269":
    case "f08372":
    case "368fc1":
    case "f3d6aa":
    case "3f9a2a":
      return {textColor: "#fff", hoverColor: "#000"};
    case "531530":
    case "e2dbc8":
    case "1daf8e":
    case "0093b1":
    case "cfe2c7":
    case "c7dbec":
      return {textColor: "#000", hoverColor: "#000"};
    default:
      return {textColor: "#000", hoverColor: "#fff"};
  }
};

export const getButtonColor = (ButtonColor) => {
  const [theme] = useGlobal("theme");
  let color = ButtonColor == "" ? theme.colors.primary : `#${ButtonColor}`;
  let hoverColor = theme.colors.primaryDark;
  const {textColor} = ButtonColor != "" && GetTextColor(ButtonColor);
  return {color, textColor, hoverColor};
};

export const footerTextClass = (bgColor) => {
  const color = bgColor.replace(/ /g, "");

  switch (color) {
    case "rgb(255,255,255)":
      return "element-link--black";
    default:
      return "element-link--white";
  }
};
export const GetCategoryColor = (category) => {
  switch (category) {
    case "Miljø":
      return "rgb(45, 132, 42)";
    case "Samfunn":
      return "rgb(139, 28, 147)";
    case "Governance":
      return "rgb(229, 142, 35)";
    default:
      return undefined;
  }
};


export const GetColorFromUnitType = (UnitType, theme, Company, GlobalUnit) => {
  if (GlobalUnit) {
    switch (Company.toLowerCase()) {
      case "hero":
        return theme?.markers.hero;
      case "nb/kidsa":
        return theme?.markers.nbKids;
      case "nhc":
        return theme?.markers.nhc;
      case "care/rehab":
        return theme?.markers.careRehab;
      case "aberia":
        return theme?.markers.aberia;
      default:
        return theme?.colors.primary;
    }
  }
  switch (UnitType) {
    case "Preschool":
      return theme?.markers?.preschool;
    case "Elderly care":
      return theme?.markers?.elderlyCare;
    case "Patient hotel":
      return theme?.markers?.patientHotel;
    case "Personal assistance":
      return theme?.markers?.personalAssistance;
    case "Disability":
      return theme?.markers?.disability;
    case "Home care":
      return theme?.markers?.homeCare;
    case "Doggy daycare":
      return theme?.markers?.doggyDaycare;
    case "Generation concept":
      return theme?.markers?.generationConcept;
    case "Assisted living":
      return theme?.markers?.assistedLiving;
    case "Secure living":
      return theme?.markers?.secureLiving;
    default:
      return theme?.colors.primary;
  }
};
